import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'nlf-ors-fallskjerm-main',
  templateUrl: './ors-fallskjerm-main.component.html',
  styleUrls: ['./ors-fallskjerm-main.component.css']
})
export class NlfOrsFallskjermMainComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
